export const DUAL_SCREEN_CLASSNAME = 'dual-screen-layout';
